import { useEffect } from 'react';
import findLast from 'lodash/findLast';

import { useLocation } from 'react-router';

import { useAppDispatch } from '@/_store/hooks';
import { useNavbarMenus } from './use-nav-bar-menu';
import type { Menu, Submenu } from '@/Interfaces/Data';
import { setRouteActive } from '@/_store/modules/layout';

const useActivatedMenuListener = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { menus: categories } = useNavbarMenus();

  const isActivedMenu = (route?: string) => {
    if (route && location.pathname?.indexOf(route) === 0) {
      return true;
    }

    return false;
  };

  function searchActivedMenu(menus: Menu[]): Submenu | null {
    let findedMenu: Menu | null = null;

    findLast(menus, menu => {
      const { submenus, href } = menu;

      if (submenus) {
        const activedSubmenu = findLast(submenus, ({ href }) =>
          isActivedMenu(href),
        );

        if (activedSubmenu) {
          findedMenu = activedSubmenu;
          return true;
        }
      }

      const isActived = isActivedMenu(href);

      if (isActived) {
        findedMenu = menu as Menu;
        return true;
      }
    });

    return findedMenu;
  }

  useEffect(() => {
    categories.forEach(menu => {
      const activedMenu = searchActivedMenu(menu?.menus || []);

      if (activedMenu) {
        dispatch(setRouteActive(activedMenu));
      }
    });
  }, [location.pathname, categories]);
};

export { useActivatedMenuListener };
